// extracted by mini-css-extract-plugin
export default {"is-used-icon":"virtual-devices_is-used-icon__DuKIr"};